<template>
  <!-- <BreadCrumb PageTitle="Register" /> -->
  <CompleteRegister :id="id" :token="token" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

// import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CompleteRegister from "../../components/Authentication/Register/CompleteRegister.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "RegisterPage",
  components: {
    // BreadCrumb,
    CompleteRegister,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id;  // <-- get the id
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }

    let token = route.params.token;  // <-- get the token
    if (Array.isArray(token)) {
      token = token[0] ?? "";
    }


    return { id, token };
}
});
</script>